import React from 'react';
import { isFolderTab } from '../../utils/collectionTabState';

/**
 * Strip / tab-search badge for a collection-strip tab: COL for a collection
 * page, DIR for a folder page (owner D1, 28.09.2026 — both are collection
 * tabs; the badge is how they are told apart at a glance).
 */
export default function CollectionTabBadge({ tab, wide = false }) {
  const folder = isFolderTab(tab);
  return (
    <span
      className={`${wide ? 'px-2 py-1 text-center' : 'px-2 py-0.5'} rounded text-xxs font-medium flex-shrink-0 bg-amber-100 text-amber-800`}
      data-tab-kind={folder ? 'folder' : 'collection'}
    >
      {folder ? 'DIR' : 'COL'}
    </span>
  );
}
